module.exports = __webpack_public_path__ + "static/media/info-gameinfo.5f34fcf0.png";